export const MEMBER_PREVIEW_STUDENT_NAME = 'Aluno (prévia)'
